export const SagaContextKey = {
  cookies: "cookies",
  session: "session",
  partners: "partners",
} as const;
